import Vue from 'vue'
import VueRouter from 'vue-router'
import VueEvents from 'vue-events'
import App from './App'
import firebase from 'firebase'
import numeral from 'numeral'
import languages from './lib/languages'
import _ from 'underscore'

import Dashboard from './components/Dashboard.vue'
import LeagueAdmin from './components/LeagueAdmin.vue'
import LeagueEdit from './components/LeagueEdit.vue'
import League from './components/League.vue'
import Countries from './components/Countries.vue'
import Fishes from './components/Fishes.vue'
import PeopleAdmin from './components/PeopleAdmin.vue'
import CountryDataPoints from './components/CountryDataPoints.vue'
import Periods from './components/Periods.vue'

Vue.use(VueEvents)
Vue.use(VueRouter)
var router = new VueRouter({
  hashbang: false,
  history: true
})

router.map({
  '/dashboard': {
    component: Dashboard
  },
  '/leagues': {
    component: LeagueAdmin
  },
  '/leagues/:key': {
    component: League
  },
  '/leagues/:key/edit': {
    component: LeagueEdit
  },
  '/leagues/:key/:lang': {
    component: League
  },
  '/countries': {
    component: Countries
  },
  '/data': {
    component: CountryDataPoints
  },
  '/fish': {
    component: Fishes
  },
  '/people': {
    component: PeopleAdmin
  },
  '/periods': {
    component: Periods
  }
})

router.redirect({
  '*': '/dashboard'
})

var config = {
  apiKey: "apiKey",
  authDomain: "overfishing-50a52.firebaseapp.com",
  databaseURL: "https://overfishing-50a52.firebaseio.com",
  storageBucket: 'gs://overfishing-50a52.appspot.com'
};
firebase.initializeApp(config);

Vue.filter('fishImg', function (value) {
  if(value.en) {
    let fishImgPath = '/static/img/fish/blue/'
    return fishImgPath + value.en.replace(/\s+/g, '-') +
      '_' + value.la.replace(/\s+/g, '-') + '.png'
  }
})

Vue.filter('flagImg', function (value) {
  if(value) {
    let flagImgPath = '/static/img/flags/'
    return flagImgPath + value.replace(/\s+/g, '-') + '.png'
  }
})

Vue.filter('formatTonnes', function (value) {
  if(value) {
    return numeral(value).format('0,0');
  }
})

Vue.filter('ordinal', function (value, lang) {
  if(value) {
    if (lang == 'en') {
      return numeral(value).format('0o').replace(value,'');
    } else {
      return '.'
    }
  }
})

Vue.filter('quotaOver', function(dataPoint) {
  return numeral(dataPoint.quotaSet - dataPoint.quotaAdvice).format(0.)
})

Vue.filter('percentOver', function(dataPoint) {
  return Math.round((100/dataPoint.quotaAdvice*dataPoint.quotaSet)-100) + "%"
})

Vue.filter('languageFromCode', function(code) {
  return _.indexBy(languages, 'code')[code].title
})

Array.prototype.insert = function (index, item) {
  this.splice(index, 0, item);
};

let Alert = {
  install: function(Vue) {
    Vue.prototype.$alert = function(msg) {
      this.$events.fire('alert', msg);
    }
  }
}
Vue.use(Alert)


router.start(App, 'app')



/** WEBPACK FOOTER **
 ** ./src/main.js
 **/